module.exports = __webpack_public_path__ + "img/4.b26ce328.png";